<ng-container *ngIf="isHamburgerMenuItem">
  <button
    mat-menu-item
    [matMenuTriggerFor]="localeMenu"
    (click)="$event.stopPropagation()"
  >
    <mat-icon>language</mat-icon>
    <span>{{ switchLanguageLabel }}</span>
  </button>
</ng-container>

<ng-container *ngIf="!isHamburgerMenuItem">
  <button
    mat-icon-button
    [attr.aria-label]="languageTooltipLabel"
    [matTooltip]="languageTooltipLabel"
    [matMenuTriggerFor]="localeMenu"
  >
    <mat-icon>language</mat-icon>
  </button>
</ng-container>

<mat-menu #localeMenu="matMenu">
  <ng-container
    *ngFor="
      let languageLocale of languageLocales;
      trackBy: languageLocaleTrackBy
    "
  >
    <button mat-menu-item (click)="onSetLanguageLocale(languageLocale)">
      {{ languageLocale.language }}
    </button>
  </ng-container>
</mat-menu>
